

















































































import { Vue, Component } from "vue-property-decorator";
import TrainPolicyService from "@/service/trainPolicyService";
import { Overlay, Loading, Skeleton, Empty } from "vant";
import productList from "../modules/productList.vue";
import * as _ from "lodash";
import { TrainSeatType } from "@/model/Base";
import moment from "moment";
import { dateDiff } from "@/utils/utils";
import trainPolicyService from "@/service/trainPolicyService";
import { join } from "lodash";
import session from "@/utils/session";
import dataShare from "../dataShare";
import LoadingFrame from "@/components/loadingFrame.vue";

@Component({
  name: "trainList",
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Skeleton.name]: Skeleton,
    "product-list": productList,
    [Empty.name]: Empty,
  },
  methods: { dateDiff },
})
export default class extends Vue {
  //data
  trainLists: any[] = [];
  lists: any[] = [];
  data = {
    train_date: (this as any).$moment().format("YYYY-MM-DD"),
    from_station: "SHH",
    to_station: "BJP",
    Consumers: [],
    BookingType: 1529, //1530
    PassengerId: "",
  };
  // overlayShow = false;
  // showSleep = false;
  isEmptyState = false;
  isEligibleContent = false;
  isShowSkeleton = true;
  filterData = {
    toStation: [],
    fromStation: [],
  };
  departTime = "";
  SortData: any = {};
  isLoading = false;
  FeatureCodes = "";

  get Consumers() {
    return JSON.parse((this as any).$route.query.Consumers);
  }
  get DepartDate(): string {
    return (this as any).$route.query.DepartDate;
  }
  get DepartCityName() {
    return this.$route.query.DepartCityName;
  }
  get ArriveCityName() {
    return this.$route.query.ArriveCityName;
  }
  get ServiceType() {
    return this.$route.query.ServiceType;
  }

  //mounted
  mounted() {
    this.departTime = this.DepartDate;
    this.getListData();
  }
  //methods
  getListData() {
    const query = this.$route.query as any;
    const data: any = this.data;
    data.train_date = this.departTime;
    data.from_station = query.DepartCity;
    data.to_station = query.ArriveCity;
    data.Consumers = this.Consumers;
    data.UniqueID = query.UniqueID;

    TrainPolicyService.getTrainLists(data).then((res: any) => {
      if (res.isSucc) {
        // return
        this.isShowSkeleton = false;
        this.isLoading = false;
        this.trainLists = _.remove(res.result.TrainInfo.entities, (a: any) => {
          return a.note == "";
        });
        this.lists = this.getFilters() as any;
        this.filterData.toStation = res.result.toStation;
        this.filterData.fromStation = res.result.fromStation;
        // this.overlayShow = false;
      } else {
        // this.showSleep = true;
        this.isEmptyState = true;
        this.isShowSkeleton = false;
        this.isLoading = false;
        // this.overlayShow = false;
        this.$root.$toast(res.message);
      }
    });
  }
  getTrainInfo(product: any): void {
    dataShare.ProductDetails = product;
    const query = this.$route.query;
    const flag = _.some(product.Seats, item => {
      return item.num > 0;
    });
    if (!flag) {
      this.$root.$toast(this.$root.$t("mall_train_trainlist_dqcczxwypqnlxqtcchlā") as string);
      return;
    }
    this.$router.push({
      path: "/mall/train/details",
      query: {
        pageIndex: "2",
        BookingType: "1529",
        DepartCity: product.from_station_code,
        ArriveCity: product.to_station_name,
        DepartDate: product.start_time,
        ServiceType: this.ServiceType,
        DepartCityName: product.from_station_name,
        ArriveCityName: product.to_station_name,
        ApplyArea: "1126",
        FeatureCodes: this.FeatureCodes,
        Consumers: query.Consumers,
        RuleType: query.RuleType,
        UniqueID: query.UniqueID,
      },
    });
  }
  matchLowest(product: any) {
    let seats = _.minBy(product.Seats, (n: any) => Number(n.fare));
    return seats || {};
  }
  getFilters(value?: any, policy?: string) {
    let __self = this;
    // fromStation: "上海虹桥,上海"
    // toStation: "北京南,北京"
    let lists = _.clone(__self.trainLists);
    let AllTrainTypes = ["G", "C", "D", "Z", "T", "K"];
    if (value && value.trainType) {
      let trainTypes: any[] = [];
      _.forEach(value.trainType.split(","), item => {
        let arr = item.split("/");
        trainTypes.push(arr);
      });
      let types: any = _.flatten(trainTypes);
      lists = _.filter(lists, item => {
        for (let i = 0; i < types.length; i++) {
          let isFlag = types[i] == item.train_type;
          if (AllTrainTypes.indexOf(item.train_type) < 0 && types[i] == (this.$root.$t("mall_train_trainlist_qita") as string)) {
            return !isFlag;
          }
          if (!isFlag) {
            continue;
          }
          return isFlag;
        }
      });
    }
    if (value && value.trainDate) {
      let train_dates = value.trainDate.split(",");
      lists = _.filter(lists, function(o) {
        for (let i = 0; i < train_dates.length; i++) {
          let train_date = train_dates[i].split("-");
          let isFlag =
            train_date[0].replace(":", "") <
              moment(o.start_date)
                .format("HH:mm")
                .replace(":", "") &&
            moment(o.start_date)
              .format("HH:mm")
              .replace(":", "") <= train_date[1].replace(":", "");
          if (!isFlag) {
            continue;
          }
          return isFlag;
        }
        return false;
      });
    }
    if (value && value.fromStation) {
      let stations = value.fromStation.split(",");
      lists = _.filter(lists, function(o) {
        for (let i = 0; i < stations.length; i++) {
          let fromStation = stations[i];
          let isFlag = fromStation == o.from_station_name;
          if (!isFlag) {
            continue;
          }
          return isFlag;
        }
        return false;
      });
    }
    if (value && value.toStation) {
      let stations = value.toStation.split(",");
      lists = _.filter(lists, function(o) {
        for (let i = 0; i < stations.length; i++) {
          let toStation = stations[i];
          let isFlag = toStation == o.to_station_name;
          if (!isFlag) {
            continue;
          }
          return isFlag;
        }
        return false;
      });
    }
    if (policy) {
      lists = _.cloneDeep(lists);
      _.forEach(lists, item => {
        _.remove(item.Seats, (i: any) => {
          if (policy == (this.$root.$t("mall_train_trainlist_fuhezhengce") as string)) {
            return i.IsContrary == 1150;
          } else {
            return i.IsContrary == 1151;
          }
        });
      });
      _.remove(lists, o => o.Seats.length == 0);
    }
    if (lists.length < 1) {
      this.isEligibleContent = true;
    }
    return (__self.lists = lists);
  }
  IsContrary(seats: any[]) {
    //有任意一个符合政策的就算不算违背政策
    const isContrary = _.find(seats, (item: any) => item.IsContrary === 1151);
    return !isContrary;
  }
  setDepartTime(date: string) {
    this.isLoading = true;
    this.departTime = date;
    this.getListData();
  }
  chnageTime(date: string) {
    this.isLoading = true;
    this.departTime = date;
    this.getListData();
  }
  // dateDiff(startDate?: Date, endDate?: Date) {
  //   return dateDiff(startDate, endDate);
  // }
  getSortData(value?: any) {
    let lists = [];
    if (value) {
      if (value.code == "AirportDepartTime") {
        lists = _.orderBy(
          this.lists,
          (item: any) => {
            return moment(item.start_time);
          },
          [value.mode]
        );
      } else {
        lists = _.orderBy(
          this.lists,
          (item: any) => {
            let Prices = _.minBy(item.Seats, (n: any) => {
              return Number(n.price);
            });
            return Prices.price;
          },
          [value.mode]
        );
      }
      this.lists = lists;
      return;
    }
  }
  getTime(value:any){
    const now = new Date();
    const dateTime = moment(value.start_time).toDate();

    const halfHourLater = new Date(now.getTime() + 30 * 60 * 1000); // 当前时间30分钟后的时间
    return dateTime > halfHourLater;
  }

  // trainStations: { [key: string]: any } = {};

  trainStations: any[] = [];
  matchStations(trainCode: string) {
    return _.find(this.trainStations, o => o.trainCode == trainCode);
  }

  expandStation(product: any) {
    let trainCode = product.train_code;
    let trainStation = this.matchStations(trainCode);
    if (trainStation) {
      trainStation.isShow = !trainStation.isShow;
      return;
    }
    trainStation = { trainCode: trainCode, isShow: true, stations: [] };
    this.trainStations.push(trainStation);

    let __self = this;

    let data = {
      train_no: product.train_no,
      train_code: product.train_code,
      train_date: moment(product.start_time).format("YYYY-MM-DD"),
      from_station: product.from_station_code,
      to_station: product.to_station_code,
    };
    trainPolicyService.getStationList(data as any).then(json => {
      if (json.isSucc) {
        trainStation.stations = json.result;
      }
    });
  }

  getTripRuleData(TripRule: any) {
    this.FeatureCodes = TripRule.FeatureCodes;
  }
  back() {
    history.back();
  }
}
